import { Routes, Route, HashRouter } from 'react-router-dom';
import { Header } from "./components";
import Home from './pages/Home';
import Service from './pages/ServicesPage';
import Contacts from './pages/ContactPage';
import About from './pages/AboutPage';
import ProjectsPage from './pages/ProjectsPage';
import GalleryPage from './pages/GalleryPage';
import ServiceDetails from './pages/ServiceDetails';
import ScrollToTop from './components/common/ScrollToTop';
import ProjectDetails from './pages/ProjectDetails';
import WhatsAppChatWidget from './components/common/ChatWidget';
import CustomCursor from './components/common/CustomCursor';

function App() {
  return (
    <HashRouter>
      <CustomCursor />
      <WhatsAppChatWidget />
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Service />} />
        <Route path="/services/:slug" element={<ServiceDetails />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects/:slug" element={<ProjectDetails />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/contacts" element={<Contacts />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
